module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1197.6420473e.png";